module.exports = __webpack_public_path__ + "img/parthner-8.346d9d30.svg";